import {
  ProductCard,
  ProductList,
  matchesMediaQuery,
  ProductForm,
  VideoMedia,
} from 'theme';
import { inView as inView6, animate as animate9, stagger } from 'vendor';

const ProductListV2 = class extends ProductList {
  constructor() {
    super(...arguments);
  }

  connectedCallback() {
    if (
      matchesMediaQuery('motion-safe') &&
      this.querySelectorAll('product-card-v2[reveal-on-scroll="true"]').length >
        0
    ) {
      inView6(this, this.reveal.bind(this));
    }
  }
  reveal() {
    animate9(
      this.querySelectorAll('product-card-v2[reveal-on-scroll="true"]'),
      {
        opacity: [0, 1],
        transform: ['translateY(20px)', 'translateY(0)'],
      },
      {
        duration: 0.2,
        easing: 'ease-in-out',
        delay: stagger(0.05, { start: 0.4, easing: 'ease-out' }),
      }
    );
  }
};

const ProductCardV2 = class extends ProductCard {
  constructor() {
    super(...arguments);
  }
};

const ProductFormV2 = class extends ProductForm {
  constructor() {
    super(...arguments);
    this.addEventListener('submit', (event) => this.onSubmit(event));
  }

  onSubmit = (event) => {
    const target = event.target;
    const overLayElement =
      target.parentElement.parentElement.parentElement.parentElement.querySelector(
        '.product-adding__overlay'
      );
    if (overLayElement) overLayElement.classList.remove('hide');
  };
};

document.addEventListener('cart:change', () => {
  const overlayElements = document.querySelectorAll('.product-adding__overlay');

  overlayElements.forEach((element) => {
    if (!element.classList.contains('hide')) element.classList.add('hide');
  });
});

window.customElements.define('product-card-v2', ProductCardV2);
window.customElements.define('product-list-v2', ProductListV2);
window.customElements.define('product-form-v2', ProductFormV2);
